import React from 'react';
import { useSearchParams } from 'react-router-dom';

const GitHubError = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');

  const getMessage = () => {
    if (reason === 'inactive') {
      return 'Usuário inativado! Entre em contato com o administrador.';
    }
    return 'Houve um problema durante o login. Tente novamente.';
  };

  return (
    <div className="error-page" style={{ textAlign: 'center', padding: '24px' }}>
      <h2>Erro no login com GitHub</h2>
      <p>{getMessage()}</p>
      <button onClick={() => window.location.href = '/login'}>
        Voltar ao Login
      </button>
    </div>
  );
};

export default GitHubError;